/* unplugin-vue-components disabled */import __unplugin_components_5 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-button.vue';
import { ElForm as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import __unplugin_components_3 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-input.vue';
import __unplugin_components_2 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-form-item.vue';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import __unplugin_components_0 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-icon.vue';
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "title"
};
import blockchain from '@/service/blockchain';
import { getChainNameByChainId } from '@/service/chains-config';
import { useCoinStore } from '@/store/coin';
import { useUserStore } from '@/store/user';
import { isSameAddress } from '@/utils/string-utils';
import { upSuccess, isMobile } from '@/utils/useUniPass';
import { isAddress } from 'ethers/lib/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'add-custom-token-dialog',
  emits: ["close", "back"],

  setup(__props, {
    emit: $emit
  }) {
    const addressElement = ref();
    const formElement = ref();
    const {
      t: $t
    } = useI18n();
    const userStore = useUserStore();
    const coinStore = useCoinStore();
    const form = reactive({
      address: '',
      symbol: '',
      decimals: '',
      loading: false,
      confirmLoading: false
    });
    let erc20Info;

    const checkAddress = async (_rule, address, callback) => {
      var _coinStore$coins;

      if (!isAddress(address)) {
        erc20Info = undefined;
        form.symbol = '';
        form.decimals = '';
        form.confirmLoading = false;
        return callback(new Error($t('InvalidAddress')));
      }

      if ((_coinStore$coins = coinStore.coins) !== null && _coinStore$coins !== void 0 && _coinStore$coins.find(token => isSameAddress(token.contractAddress, address))) {
        return callback(new Error($t('TokenAdded')));
      }

      try {
        form.loading = true;
        form.symbol = '';
        form.decimals = '';

        const _erc20Info = await blockchain.getERC20TokenInfo(address, getChainNameByChainId(userStore.chainId));

        if (!_erc20Info.isERC20) {
          return callback(new Error($t('InvalidAddress')));
        }

        form.symbol = _erc20Info.symbol;
        form.decimals = _erc20Info.decimals.toString();
        erc20Info = _erc20Info;
        callback();
      } catch (e) {
        console.error('add custom token error', e);
      } finally {
        form.loading = false;
      }
    };

    const back = () => {
      $emit('back');
    };

    const close = () => {
      $emit('close');
    };

    const addCustomToken = async () => {
      if (!form.address) {
        var _addressElement$value;

        (_addressElement$value = addressElement.value) === null || _addressElement$value === void 0 ? void 0 : _addressElement$value.focus();
      }

      if (form.address && form.symbol && form.decimals && addressElement.value && erc20Info) {
        var _coinStore$tokenLists;

        form.confirmLoading = true;
        const exit = (_coinStore$tokenLists = coinStore.tokenLists[erc20Info.chain]) === null || _coinStore$tokenLists === void 0 ? void 0 : _coinStore$tokenLists.find(token => {
          var _erc20Info2;

          return isSameAddress(token.contractAddress, (_erc20Info2 = erc20Info) === null || _erc20Info2 === void 0 ? void 0 : _erc20Info2.contractAddress);
        });

        if (exit) {
          await coinStore.addTokenToTokenList(userStore.chainId, { ...exit,
            ...erc20Info
          });
        } else {
          await coinStore.addTokenToTokenList(userStore.chainId, erc20Info);
        }

        upSuccess($t('TokenAdded'));
        form.address = '';
        form.symbol = '';
        form.decimals = '';
        form.confirmLoading = false;
        $emit('back');
      }
    };

    return (_ctx, _cache) => {
      const _component_up_icon = __unplugin_components_0;

      const _component_el_input = __unplugin_components_1;

      const _component_up_form_item = __unplugin_components_2;

      const _component_up_input = __unplugin_components_3;

      const _component_el_form = __unplugin_components_4;

      const _component_up_button = __unplugin_components_5;

      return _openBlock(), _createElementBlock("div", {
        id: "add-custom-token-dialog",
        style: _normalizeStyle({
          padding: _unref(isMobile)() ? '0 24px' : '0 40px'
        })
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_up_icon, {
        name: "back",
        class: "button",
        onClick: back
      }), _createElementVNode("div", _hoisted_2, _toDisplayString(_unref($t)('AddCustomToken')), 1), _createVNode(_component_up_icon, {
        name: "close",
        class: "header-close",
        onClick: close
      })]), _createVNode(_component_el_form, {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
        ref_key: "formElement",
        ref: formElement,
        model: form
      }, {
        default: _withCtx(() => [_createVNode(_component_up_form_item, {
          label: form.address && _unref($t)('ContractAddress'),
          prop: "address",
          rules: [{
            required: true,
            message: _unref($t)('EnterAddress'),
            trigger: 'change'
          }, {
            validator: checkAddress,
            trigger: 'change'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            ref_key: "addressElement",
            ref: addressElement,
            placeholder: _unref($t)('EnterAddress'),
            modelValue: form.address,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.address = $event),
            modelModifiers: {
              trim: true
            },
            spellcheck: false,
            type: "textarea",
            resize: "none",
            autosize: {
              minRows: 2,
              maxRows: 2
            }
          }, null, 8, ["placeholder", "modelValue"])]),
          _: 1
        }, 8, ["label", "rules"]), _createVNode(_component_up_form_item, {
          label: _unref($t)('Symbol'),
          prop: "symbol"
        }, {
          default: _withCtx(() => [_createVNode(_component_up_input, {
            modelValue: form.symbol,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.symbol = $event),
            modelModifiers: {
              trim: true
            },
            disabled: true
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["label"]), _createVNode(_component_up_form_item, {
          label: _unref($t)('Decimal'),
          prop: "decimals"
        }, {
          default: _withCtx(() => [_createVNode(_component_up_input, {
            modelValue: form.decimals,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.decimals = $event),
            modelModifiers: {
              trim: true
            },
            disabled: true
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["label"])]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_up_button, {
        type: "info",
        onClick: addCustomToken,
        loading: form.confirmLoading
      }, {
        default: _withCtx(() => [_createVNode(_component_up_icon, {
          name: "add-token"
        }), _createTextVNode(" " + _toDisplayString(_unref($t)('AddToken')), 1)]),
        _: 1
      }, 8, ["loading"])], 4);
    };
  }

});